import React, { Component } from 'react';
import './practice-more-experience.scss';
import LearningContentWrapper from '../exam-prep-kit-learning-content-wrapper/exam-prep-kit-learning-content-wrapper';
import SharedProfile from '../../../../../shared-storage/profile';
import Loading from '../../../common/loading/loading';
import ExamPrepKitApi from '../../../../apis/exam-prep-kit';
import { getImageSource } from '../../../../utility/image-source';
import { ImageConstants } from '../../../../constants/constants';
import ExamPrepKitV2Api from '../../../../apis/exam-prep-kit-v2';
import LayoutShared from "../../../common/layout-shared/layout-shared";
import StandardClassWorkExperience from './class-work/standard-classwork-experience';
import ConceptList from '../../../my-homework/classwork-concept-list-screen/classwork-concept-list';


export default class PracticeMoreExperience extends Component {

    workflowEngine = null;
    worflowNodes = [];
    questions = [];
    state = {
        learningElos: [],
        resumeIndex: 0,
        practiceButtonStatus: 'COMPLETED',
        reloadButton: true,
        isLoading: true,
    };

    CONTENT_FETCH_LIMIT = 5
    contentHash = {}

    constructor(props) {

        super(props);

        this.params = this.props.metaInfo;
        this.headerTitle = this.params && this.params.headerTitle ? this.params.headerTitle : ""
        this.progress = null;
        this.userInfo = SharedProfile.getProfile();
        this.layoutShared = LayoutShared.getLayout()
        console.log(this.params)
    }

    learnMoreParam = {}

    componentDidMount() {

        if (this.params.baseLineAssessmentActivityId) {
            this.getPracticeMoreStatus()
        } else {
            alert('No Baseline Activity Found')
        }
    }


    getPracticeMoreStatus() {
        let payload = {
            assessmentActivityId: this.params.baseLineAssessmentActivityId
        }

        this.setState({ reloadButton: false, isLoading: true })

        ExamPrepKitV2Api.getPracticeMoreStatus(payload).then(res => {
            console.log(res)
            this.setState({ reloadButton: true })
            if (res.practiceMoreStatus != 'COMPLETED') {
                this.layoutShared.toggleSidebar(true, this.props?.history?.location?.pathname)
                this.setState({
                    practiceButtonStatus: res.practiceMoreStatus,
                    showStandardClassworkExperience: false,

                    params: {
                        homeworkId: res.homeworkId,
                        nodeId: res.notAttepmted[0].id,
                        nodes: res.notAttepmted,
                        title: this.params.title,
                        concepts: res.concepts,
                        categoryThemeId: 1,
                        conceptsCovered: [],
                        homework: res,
                        typeOfSchoolwork: "EXAM_PREP_PRACTICE_MORE"
                    }
                }, () => {
                    this.showStandardHomeworkExperience()
                })
            } else {
                // All ELOs cleared — mark practice as completed in pdf_kit_activity
                if (this.params.chapterKey) {
                    ExamPrepKitV2Api.updatePdfKitActivity({
                        chapterKey: this.params.chapterKey,
                        section: 'practice',
                        isCompleted: true
                    }).catch(err => console.log('Failed to update practice status:', err));
                }
                this.setState({ practiceButtonStatus: 'COMPLETED', isLoading: false })
                // alert('Primary ELOS Not Cleared Completed')
                // this.setState({ showHomeworkConceptListScreen: true, homeworkMetaInfo: { details: res, conceptsCovered: concepts, homework: item, homeworkId: item.homeworkId, title: item.chapterTitle, categoryThemeId: 1, chapterImageUrl: item.chapterImageUrl } })
            }



        }).catch(err => {
            console.log(err)
            this.setState({ reloadButton: true })
        })


    }

    handleBackButtonClick = () => {
        return true
    }



    onPressNext = (activeIndex, callback) => {
        callback && callback()
    }



    close = () => {
        this.props.navigation.goBack()
    }

    goToLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu')
    }


    onClickLateralMenu = () => {
        this.props.navigation.navigate('LateralMenu', { meta: { from: 'PREPKIT' } })
    }

    goToHomeScreen() {
        this.props.delegate && this.props.delegate.goToHomeScreen && this.props.delegate.goToHomeScreen()
    }

    goToExamPrepKit() {
        this.props.delegate && this.props.delegate.goToExamPrepKit && this.props.delegate.goToExamPrepKit()
    }

    goToExamPrepKitChapterList() {
        this.props.showPrepKitChapterList && this.props.showPrepKitChapterList()
    }

    goBackToTableOfContents() {
        this.props.delegate && this.props.delegate.hidePracticeMoreExperience && this.props.delegate.hidePracticeMoreExperience()
    }

    goToPrepare() {
        this.props.delegate && this.props.delegate.goToPrepare && this.props.delegate.goToPrepare()
    }


    renderBreadcrumbForChapterList = () => {
        return (
            <div className='breadcrumb mt-2'>
                <span className="home cursor-pointer" onClick={() => this.goToHomeScreen()} >{`Home >`}</span>
                {/* <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToExamPrepKit()} >{`Prepare`}{` > `}</span> */}
                <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goToPrepare()}>{`${this.params.title}`} {` > `}</span>
                <span className='title-1 pl-2 cursor-pointer' onClick={() => this.goBackToTableOfContents()}>{`${`Exam Prep Kit`}`} {` > `}</span>
                <span className='title-1 pl-2' >{`Practice More`}</span>
            </div>
        )
    }


    getButtonTitle = (status) => {
        if (status == 'ASSIGNED')
            return 'Start'

        if (status == 'COMPLETED')
            return 'Completed'

        if (status == 'IN_PROGRESS')
            return 'Resume'
    }

    hideStandardClassworkExperience(data) {
        this.setState({ showStandardClassworkExperience: false }, () => {
            this.getPracticeMoreStatus()
        })
    }

    showStandardHomeworkExperience(params = this.state.params) {
        this.setState({ showStandardClassworkExperience: true, params, isLoading: false })
    }



    render() {

        if (this.state.showStandardClassworkExperience) {
            return (
                <StandardClassWorkExperience params={this.state.params} delegate={this} />
            )
        }



        return (
            <>
                {this.state.isLoading ? <Loading />

                    :
                    <div className='practice-more-experience'>
                        {
                            this.renderBreadcrumbForChapterList()
                        }
                        <div>
                            <div className='d-flex align-items-center '>
                                <div className='title'>{this.params.title}</div>
                                <div className='pl-3'>Practice More</div>

                                {this.state.practiceButtonStatus != 'COMPLETED' ?
                                    <div className={`d-flex justify-content-center button-padding`}>
                                        <div className={`button-wrapper`} >
                                            <div className="text-center start-button cursor-pointer"
                                                onClick={() => this.showStandardHomeworkExperience()}>
                                                {this.getButtonTitle(this.state.practiceButtonStatus)}
                                            </div>
                                        </div>
                                    </div>
                                    :
                                    <></>
                                }
                            </div>
                            <div className='mt-2'>
                                <img className="divider-image-width" src={getImageSource(ImageConstants.TITLE_DIVIDER)}></img>
                            </div>
                            {
                                this.state.practiceButtonStatus === 'COMPLETED' ?
                                    <ConceptList delegate={this}
                                        baseLineAssessmentActivityId={this.params.baseLineAssessmentActivityId}
                                        isEpkV2={true} /> : <></>
                            }
                            <div className='back-to-toc-container'>
                                <button
                                    type='button'
                                    className='back-to-toc-btn cursor-pointer'
                                    onClick={() => this.goBackToTableOfContents()}
                                >
                                    Back to Prepare
                                </button>
                            </div>
                        </div>
                    </div>
                }
            </>

        )
    }
}